export default "__VITE_ASSET__BR8Ngq$i__"